module.exports = __webpack_public_path__ + "static/media/perfect.6ee01229.ogg";